import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeUnmount, onMounted, ref } from 'vue';
import ModalWrapper from '@/shared/legacy/ui/modal-next/modal-wrapper.vue';
import { BaseWizard } from '@/shared/legacy/ui/base-wizard';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BaseWizardModalWrapper'
},
  __name: 'base-wizard-modal-wrapper',
  props: {
    modelValue: { type: Boolean },
    closeOnStep: {}
  },
  emits: ["update:modelValue", "step-change"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const baseWizardRef = ref<{ prev: () => void } | null>(null);
const currentStep = ref(1);

const handleEscKeyup = (event: KeyboardEvent) => {
  if (event.key !== 'Escape') {
    return;
  }

  if (!props.modelValue) {
    return;
  }

  event.stopPropagation();
  event.preventDefault();
  handleModalChange(false);
};

const handleModalChange = (value: boolean) => {
  if (!value && currentStep.value > 1) {
    if (props.closeOnStep != null && currentStep.value === props.closeOnStep) {
      emit('update:modelValue', false);
      return;
    }

    baseWizardRef.value?.prev();
    return;
  }

  emit('update:modelValue', value);
};

const handleStepChange = (step: number) => {
  currentStep.value = step;
  emit('step-change', step);
};

onMounted(() => {
  window.addEventListener('keyup', handleEscKeyup, { capture: true });
});

onBeforeUnmount(() => {
  window.removeEventListener('keyup', handleEscKeyup, { capture: true });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalWrapper, {
    open: __props.modelValue,
    onChange: handleModalChange
  }, {
    default: _withCtx(({ dismiss }) => [
      _createVNode(_unref(BaseWizard), {
        ref_key: "baseWizardRef",
        ref: baseWizardRef,
        onChange: handleStepChange
      }, {
        default: _withCtx((wizardProps) => [
          _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
              ...wizardProps,
              dismiss
            })))
        ]),
        _: 2
      }, 1536)
    ]),
    _: 3
  }, 8, ["open"]))
}
}

})